import { w } from "@/api/words";

import type { SurfaceMeta } from "../registry";

// Объявление поверхности S-04 «Залишки по гаманцях» (F-009). Тека с этим файлом — и есть
// регистрация (`../registry.ts`): пункт «Залишки по гаманцях» раздела «ГРОШІ» оживает
// вместе с ней (решение 028). Вход — пункт меню, «Вільно» без числа на `S-01` (ссылка
// «сторінці «Гаманці»»), дело «Потребує уваги» «залишки не внесено» и прямой адрес `/s-04`.
export const meta: SurfaceMeta = {
  code: "S-04",
  // Название — слово словаря по коду, читается при показе.
  get title_uk() {
    return w("s04_title");
  },
  path: "/s-04",
};
